<template>
  <div class="content-container">
    <search-section ref="searchSection" @search="onSearch" />

    <div class="grid-scroll mt-10">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        :auto-size-cell="true"
        :row-multi-select-with-click="true"
        class="agGrid"
        @rowClicked="onRowClick"
        @selectionChanged="onSelectRow"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        class="btn primary small"
        @click="
          isEdit = false
          dialogFormVisible = true
        "
      >
        {{ $t('config.profile.common.add') }}
      </button>
      <button
        class="btn primary small"
        :disabled="selectedRow.length !== 1"
        @click="
          isEdit = true
          dialogFormVisible = true
        "
      >
        {{ $t('config.profile.common.edit') }}
      </button>

      <button class="btn primary small" @click="fnGetListInvoiceCompanyToExcel">
        {{ $t('config.profile.common.exportExcel') }}
      </button>
      <button class="btn primary small" @click="importExcelVisible = true">
        {{ $t('config.profile.common.importExcel') }}
      </button>
      <button
        class="btn primary small outline"
        :disabled="selectedRow.length < 1"
        @click="fnDeleteInvoiceCompany"
      >
        {{ $t('config.profile.common.delete') }}
      </button>
    </div>

    <form-dialog
      v-model="dialogFormVisible"
      :profile-id="selectedRow.length === 1 ? selectedRow[0]?.id : null"
      :is-edit="isEdit"
      @resetSearch="onResetSearch"
    />

    <import-excel-dialog
      v-model="importExcelVisible"
      @resetSearch="onResetSearch"
    />
  </div>
</template>

<script>
/* eslint-disable */
import SearchSection from './components/SearchSection.vue'
import FormDialog from './components/FormDialog.vue'
import ImportExcelDialog from './components/ImportExcelDialog.vue'

import paginationMixin from '@/mixins/paginationMixin'

import {
  getListInvoiceCompanyApi,
  getListInvoiceCompanyToExcelApi,
  deleteInvoiceCompanyApi
} from '@/api/configuration/profile/invoiceCompany'

export default {
  components: { SearchSection, FormDialog, ImportExcelDialog },
  mixins: [paginationMixin],
  data() {
    return {
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 50,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('config.profile.field.taxCode'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          maxWidth: 120
        },
        {
          headerName: this.$t('config.profile.field.companyName'),
          field: 'name'
        },

        {
          headerName: this.$t('config.profile.field.address'),
          field: 'address'
        },

        {
          headerName: this.$t('config.profile.field.phone'),
          field: 'phone_number',
          maxWidth: 150
        },

        {
          headerName: this.$t('config.profile.field.email'),
          field: 'email',
          maxWidth: 180
        },
        {
          headerName: this.$t('config.profile.field.bankName'),
          field: 'bank_name'
        },
        {
          headerName: this.$t('config.profile.field.bankNumber'),
          field: 'bank_account_number',
          maxWidth: 140
        }
      ],

      selectedRow: [],
      rows: [],

      dialogFormVisible: false,
      importExcelVisible: false,

      isEdit: false,

      searchParams: {
        infoSearching: null,
        phoneNumber: null
      }
    }
  },
  watch: {
    dialogFormVisible(nv, ov) {
      if (!nv) {
        this.isEdit = false
      }
    }
  },

  mounted() {
    this.fnGetListInvoiceCompany()
  },

  methods: {
    // event handler
    // grid
    onRowClick(index) {},
    onDoubleClicked(rows) {
      // similar with click sua ho so
    },
    onSelectRow(value) {
      this.selectedRow = value
    },

    // pagination
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fnGetListInvoiceCompany()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fnGetListInvoiceCompany()
    },

    // search
    onResetSearch() {
      this.searchParams = {
        infoSearching: null,
        phoneNumber: null
      }
      this.pageParams = {
        pageNum: 1,
        pageSize: 10,
        totalPage: null,
        orderBy: null,
        orderTp: null // 'asc' or 'desc'
      }
      this.fnGetListInvoiceCompany()
    },

    onSearch(searchParams) {
      this.searchParams = { ...searchParams }
      this.pageParams.pageNum = 1
      this.fnGetListInvoiceCompany()
    },

    // handle call api
    fnGetListInvoiceCompany() {
      let query = {
        pageSize: this.pageParams.pageSize,
        pageNum: this.pageParams.pageNum,
        orderBy: this.pageParams.orderBy,
        orderTp: this.pageParams.orderTp,
        ...this.searchParams
      }
      getListInvoiceCompanyApi(query)
        .then(data => {
          if (!data.is_error) {
            this.rows = data.data
            this.pageParams.totalPage = Math.ceil(data.total / data.page_size)
            this.pageParams.pageNum = data.page_num
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {})
    },
    fnGetListInvoiceCompanyToExcel() {
      this.searchParams = this.$refs.searchSection.searchParams
      let query = {
        orderBy: this.pageParams.orderBy,
        orderTp: this.pageParams.orderTp,
        ...this.searchParams
      }
      getListInvoiceCompanyToExcelApi(query)
        .then(res => {
          if (!res.is_error) {
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'invoice-company-profile.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) //or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {})
    },
    fnDeleteInvoiceCompany() {
      if (this.selectedRow.length <= 0) {
        this.$alert(this.$t('config.profile.vxConfirm.alert'), 'Error', {
          confirmButtonText: this.$t('config.profile.common.confirmBtnText')
        })
        return
      }
      this.$vxConfirm(this.$t('config.profile.vxConfirm.delete'), () => {
        deleteInvoiceCompanyApi(this.selectedRow.map(row => row.id))
          .then(data => {
            if (!data.is_error) {
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${data.message}`)
              })

              this.onResetSearch()
            } else {
              throw new Error(data)
            }
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
          .finally(() => {})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.inputsearch {
  display: flex;
  margin-bottom: 20px;
}
</style>
@/api/configuration/profile/invoiceCompany
